import React, { useState, useEffect, useRef } from 'react';
import './take-quiz.styles.scss';
import ViewQuestion from '../view-question/view-question.component';
import { Question } from '../../@types/question.interface';
import Countdown from '../countdown/countdown.component';
import Loading from '../loading/loading.component';
import { fetchApi } from '../../redux/fetch/fetch.actions';
import QuestionActionAPI, {
    IFetchQuestionsPayload,
} from '../../redux/question/question.actions';
import { connect } from 'react-redux';
import { GlobalState } from '../../redux/root-reducer';
import { Dispatch } from 'redux';
import { useRouteMatch, useHistory } from 'react-router-dom';
import { Answer } from '../../@types/answer.interface';
import { User } from '../../@types/user.interface';
import {
    IInsertAnswersPayload,
    IClearAnswersPayload,
} from '../../redux/answer/answer.actions';
import Axios from 'axios';
import Moment from 'moment';
import ScoreActionAPI, {
    IInsertScorePayload,
} from '../../redux/score/score.actions';

interface IProps {
    isFetching?: boolean;
    isFetching2?: boolean;
    isFinish?: boolean;
    errors?: string | null;
    quizId: number;
    questions: Question[] | null;
    user: User;
    fetchQuestions: (id: number) => void;
    clearQuestions: () => void;
    clearQuestion: () => void;
    insertAnswers: (data: IInsertAnswersPayload['data']) => void;
    clearAnswers: (data: IClearAnswersPayload['data']) => void;
    clearScore: () => void;
    insertScore: (data: IInsertScorePayload['data']) => void;
}

function TakeQuizContainer({
    isFetching,
    isFetching2,
    isFinish,
    errors,
    quizId,
    questions,
    user,
    fetchQuestions,
    clearQuestions,
    insertAnswers,
    clearAnswers,
    clearScore,
    insertScore,
}: IProps) {
    const [index, setIndex] = useState(0);
    const match = useRouteMatch<{ id: string }>();
    const id = parseInt(match.params.id);
    const g = useRef(0);
    const [question, setQuestion] = useState<Question | null>(null);
    const [answers] = useState<Answer[]>([]);
    const [endTime, setEndTime] = useState(new Date());
    const check = useRef<boolean>(false);
    const finish = useRef<boolean>(false);
    const history = useHistory();

    const getDuration = async () => {
        const result: any = await Axios.post(
            process.env.REACT_APP_DEFAULT_API + 'quiz/takeQuiz',
            {
                quiz_id: quizId,
                email_address: user.email_address,
                start_time: Moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
            }
        );
        let temp = new Date();
        var duration: number =
            new Date(result.data.payload.data.end_time).getTime() -
            new Date().getTime();
        temp.setMilliseconds(duration);
        setEndTime(temp);
    };

    useEffect(() => {
        clearQuestions();
        window.onbeforeunload = () => window.confirm('Confirm Refresh');
        getDuration();
        return () => {
            window.onbeforeunload = null;
            clearQuestions();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        if (questions && check.current === false) {
            questions.forEach((question) => {
                answers.push({
                    quiz_id: id,
                    question_id:
                        question.question_id !== undefined
                            ? question.question_id
                            : 0,
                    email_address: user.email_address ? user.email_address : '',
                    student_answer: [{ answer: '-' }],
                });
            });
            check.current = true;
        }
    }, [user.email_address, answers, questions, id]);

    useEffect(() => {
        if (isFetching || errors) return;
        if (questions === null) fetchQuestions(id);
        if (
            isFinish === false &&
            isFetching2 === false &&
            finish.current === true
        ) {
            history.push(`/quiz/${id}/score`);
            clearScore();
        }
    }, [
        isFetching,
        isFetching2,
        errors,
        fetchQuestions,
        id,
        questions,
        isFinish,
        clearScore,
        history,
    ]);

    useEffect(() => {
        if (questions && questions?.length !== 0) setQuestion(questions[index]);
    }, [questions, id, index]);

    const handleChange = (evt: any, questionType: number) => {
        let val = evt.target.value;
        if (questionType === 2) {
            if (evt.target.checked) {
                if (
                    answers[index].student_answer.length === 1 &&
                    answers[index].student_answer[0].answer === '-'
                )
                    answers[index].student_answer[0].answer = val;
                else
                    answers[index].student_answer = answers[
                        index
                    ].student_answer.concat({ answer: val });
            } else {
                let n = -2;
                for (let i = 0; i < answers[index].student_answer.length; i++)
                    if (answers[index].student_answer[i].answer === val) n = i;
                answers[index].student_answer.splice(n, 1);
            }
        } else if (questionType === 1) {
            answers[index].student_answer[0].answer = val;
        }
    };

    const handleClick = (evt: any, name: string, idx?: number) => {
        if (evt !== undefined) evt.preventDefault();
        if (questions !== null) {
            g.current = index;
            if (name === 'next') {
                if (index + 1 > questions?.length) setIndex(questions.length);
                else {
                    setIndex(g.current + 1);
                    g.current += 1;
                }
            } else if (name === 'prev') {
                if (index - 1 < 0) setIndex(0);
                else {
                    setIndex(g.current - 1);
                    g.current -= 1;
                }
            } else if (name === 'change') {
                if (idx != null) setIndex(idx);
                g.current = index;
            } else if (name === 'finish') {
                if (user.email_address)
                    clearAnswers({
                        quiz_id: quizId,
                        email_address: user.email_address,
                    });
                let check = 0;
                answers.forEach((answer) => {
                    insertAnswers(answer);
                    check++;
                });
                if (check === answers.length && user.email_address) {
                    insertScore({
                        quiz_id: id,
                        email_address: user.email_address,
                    });
                    finish.current = true;
                }
            }
        }
    };
    return (
        <div className="take-quiz">
            {isFetching || isFetching2 || !questions || isFinish ? (
                <Loading />
            ) : (
                <div className="take-quiz__detail">
                    <div className="take-quiz__detail__header">
                        <div className="take-quiz__detail__header__index">
                            <span className="take-quiz__detail__header__index-title">
                                Question No.
                            </span>
                            <span className="take-quiz__detail__header__index-no">
                                {index + 1}
                            </span>
                        </div>
                        <div className="take-quiz__detail__header__countdown">
                            {questions.length !== 0 ? (
                                <Countdown
                                    endTime={endTime}
                                    handleClick={handleClick}
                                />
                            ) : (
                                ''
                            )}
                        </div>
                    </div>
                    <ViewQuestion
                        quizId={quizId}
                        question={question}
                        index={index}
                        setIndex={setIndex}
                        questions={questions}
                        length={questions.length}
                        answers={answers}
                        handleChange={handleChange}
                        handleClick={handleClick}
                        takeQuiz
                    />
                </div>
            )}
        </div>
    );
}

const mapStateToProps = ({
    fetchController: { isFetching, errors },
    question: { questions },
}: GlobalState) => ({
    isFetching: isFetching.QUESTIONS,
    errors: errors.QUESTIONS,
    isFinish: isFetching.INSERT_ANSWERS,
    isFetching2: isFetching.INSERT_SCORE,
    questions,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    insertScore: (data: IInsertScorePayload['data']) =>
        dispatch(fetchApi({ name: 'INSERT_SCORE', data: data })),
    fetchQuestions: (id: IFetchQuestionsPayload['data']['id']) =>
        dispatch(fetchApi({ name: 'QUESTIONS', data: { id } })),
    clearQuestions: () => dispatch(QuestionActionAPI.clearQuestions()),
    clearQuestion: () => dispatch(QuestionActionAPI.clearQuestion()),
    insertAnswers: (data: IInsertAnswersPayload['data']) =>
        dispatch(fetchApi({ name: 'INSERT_ANSWERS', data: data })),
    clearAnswers: (data: IClearAnswersPayload['data']) =>
        dispatch(fetchApi({ name: 'CLEAR_ANSWERS', data: data })),
    clearScore: () => dispatch(ScoreActionAPI.clearScore()),
});

const TakeQuiz = connect(
    mapStateToProps,
    mapDispatchToProps
)(TakeQuizContainer);

export default TakeQuiz;
